"use strict";function newRelicJSError(e){try{newrelic.noticeError(e)}catch(r){console.error("Error calling newrelic: ".concat(r)),console.error("Original error: ",e)}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.newRelicJSError=newRelicJSError;
//# sourceMappingURL=new_relic_helper.js.map
